export default (props, vars) =>
  `student-card-2-${vars?.['defaultforeach1']?.['item'].id}`;
